import { Override } from '@shared/utils/overrides';
import { BoxProps, CheckboxV2, styled } from '@withjoy/joykit';

export const StyledCheckboxV2 = styled(CheckboxV2)``;

export const checkboxOverrides: {
  Root?: Override<BoxProps>;
  Control?: Override<BoxProps>;
} = {
  Root: {
    props: {
      color: 'newUITest1',
      borderColor: 'newUITest1'
    }
  },
  Control: {
    props: {
      _checked: {
        color: 'newUITest1',
        borderColor: 'newUITest1'
      },
      _focus: {
        boxShadow: 'none'
      }
    }
  }
};
